export const useLogin = (context) => {
  const toLoginPage = url => {
    context.$router.push({
      path: '/login',
      query: {
        redirect: url || location.href
      }
    })
  }
  return { toLoginPage }
}

export const useAnimate = (context) => {
  const animate = () => {
    // 创建观察器
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(item => {
        // 元素进入视口
        if (item.isIntersecting) {
          item.target.classList.add(...item.target.dataset.animate.split(' '))
          // 只触发一次动画，观察后取消监听
          observer.unobserve(item.target)
        }
      })
    }, {
      root: null, // 根容器默认视口
      threshold: 0.2 // 元素露出20%就触发动画
    })

    // 批量监听所有带data-animate标记的元素
    document.querySelectorAll('[data-animate]').forEach(el => {
      observer.observe(el)
    })
  }
  return { animate }
}
